import React from 'react';
import { motion } from 'framer-motion';
export function ContactHero() {
  return <section className="relative pt-32 pb-20 lg:pt-48 lg:pb-24 overflow-hidden bg-brand-cream" data-id="element-642">
      <div className="absolute top-0 left-0 w-[600px] h-[600px] bg-gradient-to-br from-brand-gold/[0.08] to-brand-purple/[0.05] rounded-full blur-3xl -translate-x-1/2 -translate-y-1/4 animate-float pointer-events-none" data-id="element-643" />

      <div className="max-w-4xl mx-auto px-6 relative z-10 text-center" data-id="element-644">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        ease: 'easeOut'
      }} data-id="element-645">
          <h1 className="text-5xl md:text-6xl lg:text-[64px] leading-[1.1] font-bold text-brand-text mb-8" data-id="element-646">
            CONTACT
          </h1>
          <p className="font-subtitle font-medium text-xl md:text-2xl text-brand-textSec leading-relaxed text-balance max-w-3xl mx-auto" data-id="element-647">
            Te pot ghida mai departe, simplu și direct. Dacă ai o întrebare,
            vrei detalii despre cursuri sau vrei să rezervi o sesiune gratuită
            de evaluare, mai jos ai toate canalele prin care mă poți contacta.
          </p>
        </motion.div>
      </div>
    </section>;
}